var _circle, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrevSlideDynamic = function SvgPrevSlideDynamic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    transform: "rotate(180 22 22)",
    fill: "current"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5993 28.1563L24.5992 28.1562L18.4309 21.9999L24.5993 15.8315C24.8544 15.5764 24.8544 15.1622 24.5993 14.9071C24.3443 14.6521 23.9301 14.6521 23.675 14.9071L17.0566 21.5256C16.9297 21.6524 16.8653 21.8136 16.8653 21.9877C16.8653 22.1476 16.9284 22.3217 17.0566 22.4499L23.6735 29.0668C23.9288 29.3361 24.3443 29.3357 24.5993 29.0806C24.8544 28.8255 24.8544 28.4113 24.5993 28.1563Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.84,
    height: 15.84,
    fill: "white",
    transform: "translate(29.9199 14.08) rotate(90)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrevSlideDynamic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prev-slide-dynamic.a3d14844.svg";
export { ForwardRef as ReactComponent };